
(() => {
  function vertaalBezorgdatum() {
    document.querySelectorAll(
     '.ot-dingdong-calendar__popover-button-label, .ot-dingdong-dropdown__button-content span'
    ).forEach(span => {
      if (/shipping date/i.test(span.textContent)) {
        span.textContent = 'Kies je bezorgdatum';
      }
    });

    const engels =
      'Please choose a shipping date and time before checkout';
    const nederlands =
      'Kies eerst je bezorgdatum voordat je afrekent.';

    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT
    );

    let node;
    
while ((node = walker.nextNode())) {
  const tekst = node.nodeValue;

  if (tekst.trim().toLowerCase() === 'shipping date') {
    node.nodeValue = 'Kies je bezorgdatum';
  } else if (tekst.includes(engels)) {
    node.nodeValue = tekst.replace(engels, nederlands);
  }
}

  }

  function start() {
    vertaalBezorgdatum();

    const observer = new MutationObserver(vertaalBezorgdatum);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
